import React, { useState } from "react";
import { X, Lightbulb } from "lucide-react";

const SetPriceModal = ({
  rideName = "Cab Premium",
  basePrice = 405,
  onClose,
}) => {
  const [priceOffset, setPriceOffset] = useState(0); // -40 to +80

  const handleSliderChange = (e) => {
    setPriceOffset(Number(e.target.value));
  };

  const finalPrice = basePrice + priceOffset;
  const isNegative = priceOffset < 0;
  const barColor = isNegative ? "bg-red-500" : "bg-green-600";

  return (
    <div className="fixed inset-0 bg-black/40 flex items-end justify-center z-50">
      {/* Bottom sheet */}
      <div className="bg-white w-full max-w-md rounded-t-3xl p-5 pb-8 shadow-lg animate-slideUp relative">
        {/* Close */}
        <button
          onClick={onClose}
          className="absolute right-5 top-5 text-gray-500 hover:text-gray-700"
        >
          <X className="w-5 h-5" />
        </button>

        {/* Header */}
        <h3 className="text-lg font-semibold text-center text-gray-900 mt-3">
          Now you can set a price that works for you
        </h3>

        {/* Price Display */}
        <div className="text-center mt-6">
          <div className="inline-block bg-gray-100 px-6 py-3 rounded-xl">
            <span className="text-2xl font-semibold text-gray-900">
              ₹{finalPrice}
            </span>
          </div>

          <div className="flex items-center justify-center mt-3 text-gray-500 text-sm">
            <Lightbulb className="w-4 h-4 mr-1 text-gray-400" />
            Higher the price, higher the chance of getting a ride
          </div>
        </div>

        {/* Slider */}
        <div className="mt-8 px-4">
          <div className="flex justify-between text-xs text-gray-600 mb-2">
            <span>-40</span>
            <span>-20</span>
            <span>0</span>
            <span>+20</span>
            <span>+40</span>
            <span>+60</span>
            <span>+80</span>
          </div>

          <input
            type="range"
            min={-40}
            max={80}
            step={5}
            value={priceOffset}
            onChange={handleSliderChange}
            className="w-full h-2 appearance-none rounded-full bg-gray-200"
            style={{
              background: `linear-gradient(to right, ${
                isNegative ? "#ef4444" : "#16a34a"
              } ${(priceOffset + 40) / 1.2}%, #e5e7eb ${(priceOffset + 40) / 1.2}%)`,
            }}
          />

          <div className="text-center mt-2 text-sm text-gray-700">
            Offset: {priceOffset >= 0 ? `+${priceOffset}` : priceOffset}
          </div>
        </div>

        {/* Button */}
        <button className="mt-8 w-full bg-primary text-white font-semibold py-3 rounded-full text-sm hover:opacity-90 transition">
          Book {rideName} for ₹{finalPrice}
        </button>
      </div>

      {/* Animation */}
      <style jsx>{`
        @keyframes slideUp {
          from {
            transform: translateY(100%);
          }
          to {
            transform: translateY(0);
          }
        }
        .animate-slideUp {
          animation: slideUp 0.3s ease-out;
        }

        /* Custom slider thumb */
        input[type="range"]::-webkit-slider-thumb {
          height: 20px;
          width: 20px;
          background: white;
          border: 3px solid #16a34a;
          border-radius: 50%;
          cursor: pointer;
          transition: 0.2s;
          appearance: none;
        }

        input[type="range"]::-webkit-slider-thumb:hover {
          transform: scale(1.1);
        }
      `}</style>
    </div>
  );
};

export default SetPriceModal;